<ts-button variant="secondary" icon="ts_calendar" [tsOverlayTriggerFor]="overlay">
  Report Period
  <ts-badge [value]="getReportPeriodBadgeLabel(reportPeriod())" type="info"></ts-badge>
</ts-button>

<ts-overlay transparentBackdrop="true" position="bottom" #overlay>
  <div class="flex flex-col">
    <ts-date-range
      class="px-2"
      [value]="initialReportPeriodRange()"
      [presets]="reportPeriodPresets"
      (rangeChanged)="updateNewReportPeriod($event)"
    />
    <ts-divider spacing="sm" />
    <div class="w-full flex flex-row items-center justify-between px-4" ts-dialog-actions>
      <a
        class="text-disabled-light flex flex-row items-center gap-1"
        href="https://help.termsheet.com/"
        target="_blank"
      >
        <ts-icon color="light-gray" icon="ts_question-circle" />
        Learn about report periods
      </a>
      <ts-button variant="primary" [loading]="loading()" (click)="applyNewReportPeriod()">Apply</ts-button>
    </div>
  </div>
</ts-overlay>
